<div class="validation-success">
  <i class="fa fa-check" aria-hidden="true"></i>
  <p>{{ labelKey | i18next }}</p>
</div>
